export default {
  ERRORMODAL_01: '下载超出限制',
  ERRORMODAL_02: 'AI生成达到使用限制，请升级',
  ERRORMODAL_03: '升级',
  ERRORMODAL_04: '数量超出限制',
  ERRORMODAL_05: '工作台同时编辑文件数量达到使用限制，请升级',
  ERRORMODAL_06: '升级',
  ERRORMODAL_07: '生成超出限制',
};
